import { Injectable, signal } from '@angular/core';
import { SidebarState } from './menu.model';

/**
 * Whether the rail is on screen, and which of its sections are folded away.
 *
 * Ported verbatim from evo-accounts `core/services/sidebar-state.service.ts`.
 *
 * Nothing here is persisted, and that is deliberate rather than an omission:
 * evo-accounts does not persist it either. There is no `localStorage` read to
 * guard on the server and no first-paint flash of a rail in the wrong state —
 * the shell renders the same way on the server and in the browser.
 *
 * Both writers replace the whole state object, so every write publishes a new
 * identity. That is safe because the only writers are user gestures; nothing
 * writes from an effect, so a new identity cannot feed back into itself.
 */
@Injectable({ providedIn: 'root' })
export class SidebarStateService {
  readonly state = signal<SidebarState>({
    isHidden: false,
    collapsedSections: new Set<string>(),
  });

  update(partial: Partial<SidebarState>): void {
    this.state.update(s => ({ ...s, ...partial }));
  }

  toggleHidden(): void {
    this.state.update(s => ({ ...s, isHidden: !s.isHidden }));
  }
}
